import { HTMLProps, FunctionComponent, RefObject, ReactElement } from 'react';
import { useTheme } from 'emotion-theming';
import styled from '@emotion/styled';

import Loader from '@app/components/Loader';
import { rem } from '@app/styles/theme/layout';
import { AppTheme } from '@app/styles/theme';

import {
  Container,
  Label,
  fieldStyles,
  invalidStyles,
  floatingStyles,
} from './common.styles';

const Input = styled.input`
  ${fieldStyles}
  ${invalidStyles}

  &:not(:placeholder-shown) + label,
  &:focus + label {
    ${floatingStyles}
  }
`;

const InputLoader = styled(Loader)`
  position: absolute;
  top: ${rem(20)};
  right: ${rem(18)};
`;

interface TextFieldProps extends HTMLProps<HTMLInputElement> {
  isValid?: boolean;
  formLabel: string | ReactElement;
  half?: boolean;
  innerRef?: RefObject<HTMLInputElement>;
  loading?: boolean;
}

const TextField: FunctionComponent<TextFieldProps> = ({
  formLabel,
  isValid,
  half,
  innerRef,
  loading,
  ...props
}) => {
  const theme: AppTheme = useTheme();

  return (
    <Container half={half}>
      <Input
        aria-invalid={isValid === false ? 'true' : 'false'}
        type="text"
        id={props.name}
        {...props}
        ref={innerRef}
        placeholder=" "
      />
      <Label htmlFor={props.id || props.name}>{formLabel}</Label>
      {loading && <InputLoader color={theme.colors.labelGray} />}
    </Container>
  );
};

export default TextField;
